import React, { useState, useEffect } from "react";
import { Switch } from "react-router-dom";
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import Container from 'react-bootstrap/Container';
import NavDropdown from 'react-bootstrap/NavDropdown';
import { LinkContainer, IndexLinkContainer } from "react-router-bootstrap";
import logo from './logo_rnr.svg';
import { useHistory } from "react-router-dom";
import { Auth } from "aws-amplify";

import MyFooter from './containers/MyFooter';
import Login from './containers/Login';
import Home from './containers/Home';
import Price from './containers/Price';
import Analyse from './containers/Analyse';
import About from './containers/About';
import Glossary from './containers/Glossary';
import Resources from './containers/Resources';
import Settings from './containers/Settings';
import Upload from './containers/Upload';
import View from './containers/View';
import getData from './containers/TestAPI';
import NotFound from "./containers/NotFound";
import { onError } from "./libs/errorLib";
import AuthenticatedRoute from "./components/AuthenticatedRoute";
import UnauthenticatedRoute from "./components/UnauthenticatedRoute";
import { AppContext } from "./libs/contextLib";
import { startCase } from 'lodash';

function App() {
  const history = useHistory();
  const [isAuthenticated, userHasAuthenticated] = useState(false);
  const [isAuthenticating, setIsAuthenticating] = useState(true);
  const [userName, setUserName] = useState(null);

  useEffect(() => {
    onLoad();
  }, [isAuthenticated]);
  
  async function onLoad() {
    try {
      await Auth.currentSession();
      userHasAuthenticated(true);
      Auth.currentAuthenticatedUser().then((user) => {
        //console.log('username = ' + user);
        setUserName(startCase(user.username));
        //console.log('username from state= ' +  userName);
      });

    }
    catch(e) {
      if (e !== 'No current user') {
        //alert(e);
        onError(e);
      }
    }
  
    setIsAuthenticating(false);
  }
  
  async function handleLogout() {
    try {
      await Auth.signOut();
      userHasAuthenticated(false);
      //console.log(Auth.currentUserInfo());
      history.push("/login");
      //console.log('signed out alridi');
    } catch (error){
      console.error('error', error);
    }
  }

  return (
    <AppContext.Provider value={{ isAuthenticated, userHasAuthenticated, userName }}>
      {!isAuthenticating && (
        <div className="App">
          {isAuthenticated ? (
            <>
            <Navbar collapseOnSelect expand="lg" bg="light">
              <Container>
              <LinkContainer to="/home">
                <Navbar.Brand>
                  <img
                    alt=""
                    src={logo}
                    width="35"
                    height="35"
                    className="d-inline-block align-top"
                  />{' '}
                  SCI-ASEAN Green Research Hackathon
                </Navbar.Brand>
              </LinkContainer>

              <Navbar.Toggle aria-controls="responsive-navbar-nav" />
              <Navbar.Collapse id="responsive-navbar-nav">
                <Nav className="me-auto" activeKey={window.location.pathname}>
                  <LinkContainer to="/home">
                    <Nav.Link>Home</Nav.Link>
                  </LinkContainer>
                  <LinkContainer to="/analyse">
                    <Nav.Link>Analyse</Nav.Link>
                  </LinkContainer>
                  <LinkContainer to="/price">
                    <Nav.Link>Price</Nav.Link>
                  </LinkContainer>
                  <NavDropdown title="Data" id="basic-nav-dropdown1">
                    <IndexLinkContainer to="/data/view">
                      <NavDropdown.Item>View</NavDropdown.Item>
                    </IndexLinkContainer>
                    <IndexLinkContainer to="/data/upload">
                      <NavDropdown.Item>Upload</NavDropdown.Item> 
                    </IndexLinkContainer>
                  </NavDropdown>
                  <NavDropdown title="Info" id="basic-nav-dropdown2">
                    <IndexLinkContainer to="/glossary">
                      <NavDropdown.Item>Glossary</NavDropdown.Item>
                    </IndexLinkContainer>
                    <IndexLinkContainer to="/resources">
                      <NavDropdown.Item>Resources</NavDropdown.Item> 
                    </IndexLinkContainer>
                    <NavDropdown.Divider />
                    <IndexLinkContainer to="/about">
                      <NavDropdown.Item>About</NavDropdown.Item> 
                    </IndexLinkContainer>
                  </NavDropdown>
                </Nav>
                <Nav className="ml-auto">
                  <NavDropdown title={userName} id="basic-nav-dropdown3">
                    <IndexLinkContainer to="/settings">
                      <NavDropdown.Item>Settings</NavDropdown.Item>
                    </IndexLinkContainer>
                    <NavDropdown.Divider />
                    <IndexLinkContainer to="/login">
                      <NavDropdown.Item onClick={handleLogout}>Logout</NavDropdown.Item>
                    </IndexLinkContainer>
                 </NavDropdown>
                </Nav>
              </Navbar.Collapse>
              </Container>
            </Navbar>

{/*             <Navbar bg="light" expand="lg">
              <LinkContainer to="/home">
                <Navbar.Brand>
                  <img
                    alt=""
                    src={logo}
                    width="35"
                    height="35"
                    className="d-inline-block align-top"
                  />{' '}
                  SCI-ASEAN Green Research Hackathon
                </Navbar.Brand>
              </LinkContainer>
              <Navbar.Toggle aria-controls="basic-navbar-nav" />
              <Navbar.Collapse id="basic-navbar-nav">
              <Nav className="mr-auto container-fluid" activeKey={window.location.pathname}>

              <LinkContainer to="/home">
                    <Nav.Link>Home</Nav.Link>
                  </LinkContainer>
                  <LinkContainer to="/analyse">
                    <Nav.Link>Analyse</Nav.Link>
                  </LinkContainer>
                  <LinkContainer to="/price">
                    <Nav.Link>Price</Nav.Link>
                  </LinkContainer>
                  <NavDropdown title="Data" id="basic-nav-dropdown1">
                    <IndexLinkContainer to="/data/view">
                      <NavDropdown.Item>View</NavDropdown.Item>
                    </IndexLinkContainer>
                    <IndexLinkContainer to="/data/upload">
                      <NavDropdown.Item>Upload</NavDropdown.Item> 
                    </IndexLinkContainer>
                  </NavDropdown>
                  <NavDropdown title="Info" id="basic-nav-dropdown2">
                    <IndexLinkContainer to="/glossary">
                      <NavDropdown.Item>Glossary</NavDropdown.Item>
                    </IndexLinkContainer>
                    <IndexLinkContainer to="/resources">
                      <NavDropdown.Item>Resources</NavDropdown.Item> 
                    </IndexLinkContainer>
                    <NavDropdown.Divider />
                    <IndexLinkContainer to="/about">
                      <NavDropdown.Item>About</NavDropdown.Item> 
                    </IndexLinkContainer>
                  </NavDropdown>

                  <Nav.Link className="ml-auto" onClick={handleLogout}>Logout {userName}</Nav.Link>    
                </Nav>
              </Navbar.Collapse>
            </Navbar>  */}

            </>
          ) : (
            <>
              <Navbar bg="light" expand="lg">
                <LinkContainer to="/login">
                  <Navbar.Brand>
                    <img
                      alt=""
                      src={logo}
                      width="35"
                      height="35"
                      className="d-inline-block align-top"
                    />{' '}
                    SCI-ASEAN Green Research Hackathon
                  </Navbar.Brand>
                </LinkContainer>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                  <Nav className="mr-auto" activeKey={window.location.pathname}>
                    <LinkContainer to="/login">
                      <Nav.Link>Login</Nav.Link>
                    </LinkContainer>
                  </Nav>
                </Navbar.Collapse>
              </Navbar> 
            </>
          )}

          <Switch>
            <UnauthenticatedRoute exact path='/login' component={Login}/>
            <AuthenticatedRoute exact path='/' component={Home}/>
            <AuthenticatedRoute exact path='/home' component={Home}/>
            <AuthenticatedRoute exact path='/analyse' component={Analyse}/>
            <AuthenticatedRoute exact path='/price' component={Price}/>
            <AuthenticatedRoute exact path='/about' component={About}/>
            <AuthenticatedRoute exact path='/glossary' component={Glossary}/>
            <AuthenticatedRoute exact path='/resources' component={Resources}/>
            <AuthenticatedRoute exact path='/settings' component={Settings}/>
            <AuthenticatedRoute exact path='/data/view' component={View}/>
            <AuthenticatedRoute exact path='/data/upload' component={Upload}/>
            <AuthenticatedRoute exact path='/api/test' component={getData}/>
            {/* Finally, catch all unmatched routes */}
            <AuthenticatedRoute>
              <NotFound />
            </AuthenticatedRoute>
          </Switch>
          <MyFooter />
        </div>
      )}
    </AppContext.Provider>
  )
}      

export default App;
